import styled from 'styled-components';

export const ProfilePageStyled = styled.div`
    display: flex;
    flex-direction: column;
    gap: var(--space-4);
    max-width: 800px;
    margin: 0 auto;
    padding-bottom: var(--space-6);

    .page-header {
        display: flex;
        flex-direction: column;
        gap: var(--space-1);
        margin-bottom: var(--space-2);
    }

    .page-title {
        margin: 0;
        font-size: var(--font-size-h3);
        font-weight: 600;
        line-height: 1.25;
        color: var(--color-white-95);
    }

    .page-desc {
        margin: 0;
        font-size: var(--font-size-md);
        color: var(--text-color-secondary);
    }
`;

export const ProfileSectionStyled = styled.section`
    padding: var(--space-5) var(--space-4);
    background: var(--color-surface);
    border-radius: var(--radius-md);

    .section-header {
        display: flex;
        flex-wrap: wrap;
        align-items: flex-start;
        justify-content: space-between;
        gap: var(--space-3) var(--space-6);
        margin-bottom: var(--space-5);
    }

    .section-heading {
        display: flex;
        flex-direction: column;
        gap: var(--space-1);
        min-width: 0;
    }

    .section-title {
        margin: 0;
        font-size: var(--font-size-h4);
        font-weight: 600;
        color: var(--color-white-95);
    }

    .section-desc {
        margin: 0;
        font-size: var(--font-size-md);
        color: var(--text-color-secondary);
    }

    .section-error {
        margin: 0 0 var(--space-4);
        font-size: var(--font-size-md);
        color: var(--color-negative);
    }

    .section-actions {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: var(--space-2);
        margin-top: var(--space-5);
    }
`;

export const ProfileFormGridStyled = styled.div`
    display: flex;
    flex-direction: column;
    gap: var(--space-4);
`;

export const ProfileCredentialRowStyled = styled.div`
    display: flex;
    flex-direction: column;
    gap: var(--space-1);
    padding: var(--space-3) var(--space-4);
    background: var(--color-surface-secondary);
    border-radius: var(--radius-md);

    & + & {
        margin-top: var(--space-3);
    }

    .credential-label {
        font-size: var(--font-size-xs);
        color: var(--text-color-secondary);
    }

    .credential-value {
        display: flex;
        align-items: center;
        gap: var(--space-2);
        min-width: 0;
    }

    .credential-text {
        margin: 0;
        font-size: var(--font-size-md);
        font-weight: 600;
        color: var(--color-white-95);
        word-break: break-all;
        overflow-wrap: anywhere;
    }
`;

export const ProfileApiDocsBodyStyled = styled.div`
    max-height: min(70vh, 560px);
    overflow-y: auto;
    padding-right: var(--space-2);

    .docs-section {
        margin-bottom: var(--space-5);

        &:last-child {
            margin-bottom: 0;
        }
    }

    .docs-section h3 {
        margin: 0 0 var(--space-2);
        font-size: var(--font-size-base);
        font-weight: 600;
        color: var(--color-white-95);
    }

    .docs-section p {
        margin: 0 0 var(--space-3);
        font-size: var(--font-size-md);
        line-height: 1.5;
        color: var(--text-color-secondary);
    }

    .docs-section ul {
        margin: 0 0 var(--space-3);
        padding-left: 1.25rem;
        font-size: var(--font-size-md);
        line-height: 1.5;
        color: var(--text-color-secondary);
    }

    .docs-section li + li {
        margin-top: var(--space-2);
    }

    .docs-section code,
    .docs-code {
        display: inline-block;
        padding: 1px 6px;
        font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
        font-size: var(--font-size-sm);
        color: var(--color-white-95);
        background: var(--color-surface-secondary);
        border-radius: var(--radius-sm);
        word-break: break-all;
    }

    .docs-example {
        margin: 0;
        padding: var(--space-3);
        font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
        font-size: var(--font-size-sm);
        line-height: 1.45;
        color: var(--color-white-95);
        background: var(--color-surface-secondary);
        border-radius: var(--radius-md);
        white-space: pre-wrap;
        word-break: break-word;
    }
`;
